<script setup lang="ts">
import type { ComputedRef } from "vue";
import { SelectValue, type SelectValueProps, useForwardProps } from "reka-ui";

const props = withDefaults(defineProps<SelectValueProps>(), {});
// Only the set props; typed as such (see HPixSelectArrow).
const forwarded = useForwardProps(props) as ComputedRef<SelectValueProps>;
</script>

<template>
  <SelectValue v-bind="forwarded">
    <slot />
  </SelectValue>
</template>
